export const dev_endpont = 'http://localhost:5000/api'
export const prodcution_endpoint = 'https://dev.baganads.com/node/api'